import { render, staticRenderFns } from "./admin-navigation.vue?vue&type=template&id=5faeac7c&"
import script from "./admin-navigation.vue?vue&type=script&lang=js&"
export * from "./admin-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports